
interface InstitutionOfficerPayload {
    sponsored: boolean;
    new_user: {
        user_data: {
            designation: string | null;
            first_name: string | null;
            last_name: string | null;
            date_of_birth: string | null;
            tax_id: string | null;
            home_phone_number: string | null | null;
            business_phone_number: string | null | null;
            office_email_address: string | null;
            personal_email_address: string | null;
        };
        person_data: {
            date_of_birth: string | null;
            tax_id: string | null;
            gender: string | null;
            mobile_phone_contact_attributes: {
                mobile_phone_number: string | null | null;
            };
            mailing_address_attributes: Record<string, any> | null;
            isMatchPerson: boolean | null;
        };
    };
    role_assignments: {
        employee_roster?: {
            role: string | null;
            institution: {
                client_number: string | null;
            };
        }[] | null;
        customer_360?: {
            role: string | null;
            institution: {
                client_number: string | null;
            };
        }[] | null;
    } | null;
}

export function removeNullUndefined(obj) {
    return Object.keys(obj).reduce((acc, key) => {
        if (obj[key] !== null && obj[key] !== undefined) {
            if (typeof obj[key] === 'object') {
                const newObj = removeNullUndefined(obj[key]);
                if (Object.keys(newObj).length !== 0) {
                    acc[key] = newObj;
                } else if (
                    (key === 'mailing_address_attributes' || key === 'mobile_phone_contact_attributes') &&
                    Object.keys(obj[key]).length === 0
                ) {
                    acc[key] = obj[key];
                }
            } else {
                acc[key] = obj[key];
            }
        }
        return acc;
    }, {});
}

function transformRoleAssignments(data: InstitutionOfficerPayload): InstitutionOfficerPayload {
    const newData = { ...data };
    const employeeRoster = newData.role_assignments?.employee_roster;
    const cicRoster = newData.role_assignments?.customer_360;
    if (employeeRoster && !Array.isArray(employeeRoster)) {
        const transformedRoster: { role: string; institution: { client_number: string; }; }[] = Object.values(employeeRoster);
        newData.role_assignments = {
            employee_roster: transformedRoster,
        };
    }
    if (cicRoster && !Array.isArray(cicRoster)) {
        const transformedRoster: { role: string; institution: { client_number: string; }; }[] = Object.values(cicRoster);
        newData.role_assignments = {
            ...newData.role_assignments,
            customer_360: transformedRoster,
        };
    }
    return newData;
}

export function cleanData(data) {
    const cleanedData : any = removeNullUndefined(data);
    
    // Manually add back empty objects for specific keys if they were deleted
    if (!cleanedData?.new_user?.person_data?.mailing_address_attributes) {
        cleanedData.new_user.person_data.mailing_address_attributes = {};
    }
    if (!cleanedData?.new_user.person_data?.mobile_phone_contact_attributes) {
        cleanedData.new_user.person_data.mobile_phone_contact_attributes = {};
    }
    
    return transformRoleAssignments(cleanedData);
}